var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgWirelessOffIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.6014 12.8158C6.20448 13.2127 6.20448 13.8563 6.6014 14.253C6.99846 14.65 7.64188 14.65 8.0388 14.253C9.12021 13.1716 10.8801 13.1716 11.9615 14.253C12.1601 14.4514 12.4202 14.5508 12.6803 14.5508C12.9404 14.5508 13.2005 14.4516 13.3991 14.253C13.796 13.8561 13.796 13.2126 13.3991 12.8158C11.5249 10.9416 8.47556 10.9416 6.6014 12.8158Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.6224 9.83716C3.22548 10.2341 3.22548 10.8776 3.6224 11.2744C4.01932 11.6712 4.66274 11.6715 5.0598 11.2744C7.7839 8.55031 12.2164 8.55031 14.9404 11.2744C15.1389 11.4728 15.3991 11.5721 15.6592 11.5721C15.9192 11.5721 16.1794 11.473 16.3779 11.2744C16.7749 10.8775 16.7749 10.2339 16.3779 9.83716C12.8612 6.32056 7.13913 6.32056 3.6224 9.83716Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7024 6.51247C14.3524 1.16251 5.64752 1.16251 0.297691 6.51247C-0.0992303 6.9094 -0.0992303 7.55295 0.297691 7.94974C0.694748 8.34666 1.33817 8.34666 1.73509 7.94974C3.94262 5.74208 6.87786 4.52638 9.99997 4.52638C13.1221 4.52638 16.0573 5.74221 18.2649 7.94974C18.4634 8.14813 18.7236 8.24746 18.9836 8.24746C19.2437 8.24746 19.5039 8.14827 19.7024 7.94974C20.0993 7.55295 20.0993 6.9094 19.7024 6.51247Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0002 17.599C10.6162 17.599 11.1156 17.0996 11.1156 16.4836C11.1156 15.8676 10.6162 15.3682 10.0002 15.3682C9.38416 15.3682 8.88477 15.8676 8.88477 16.4836C8.88477 17.0996 9.38416 17.599 10.0002 17.599Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5893 2.68305L19.9428 2.3295L19.5893 1.97594L18.2635 0.650119L17.9099 0.296565L17.5563 0.650119L1.64645 16.56L1.29289 16.9136L1.64645 17.2671L2.97227 18.593L3.32583 18.9465L3.67938 18.593L19.5893 2.68305Z",
    fill: "white",
    stroke: "#3A393C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgWirelessOffIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/wireless-off-icon.12ad187b.svg";
export { ForwardRef as ReactComponent };